(function () {
  if (window.__charmeaseCartInit) return;
  window.__charmeaseCartInit = true;

  /* 3 AL 2 ODE mekanigi: musteri 2 alir, 1 bedava alir (tum-urunler koleksiyonu).
     Yani her 3 uründe 1 tanesi bedava. Siparis basina limit yok.
     Sepette bu ilerleme hic gosterilmiyordu: musteri reklamda "3 AL 2 ODE" gorup
     sepete 1 urun ekliyor, indirim gormuyor ve cikiyor. Sepetten odemeye gecis
     %52 ile hunideki en zayif halka. Bu blok tam olarak orayi hedefliyor. */

  var GRUP = 3; /* kac uründe 1 bedava */
  var STYLE_ID = 'charmease-cart-styles';

  var CSS = [
    '.chm-bxgy{border:1px solid var(--color-border,rgba(0,0,0,.12));border-radius:10px;padding:14px 16px;margin-block-end:16px;}',
    '.chm-bxgy__mesaj{margin:0 0 10px;font-size:0.875rem;line-height:1.4;color:var(--color-foreground,#111);}',
    '.chm-bxgy__mesaj b{font-weight:700;}',
    '.chm-bxgy__bar{position:relative;height:6px;border-radius:999px;background:var(--color-border,rgba(0,0,0,.12));overflow:hidden;}',
    '.chm-bxgy__dolu{position:absolute;inset-block:0;inset-inline-start:0;border-radius:999px;background:var(--color-foreground,#111);transition:width .35s ease;}',
    '.chm-bxgy--tamam .chm-bxgy__dolu{background:#1e7f4f;}',
    '.chm-bxgy--tamam{border-color:#1e7f4f;background:rgba(30,127,79,.06);}',
    '.chm-bxgy__alt{margin:8px 0 0;font-size:0.75rem;line-height:1.45;color:var(--color-foreground-subdued,rgba(0,0,0,.6));}',
    '.chm-bxgy__kazanc{color:#1e7f4f;font-weight:700;}'
  ].join('');

  function stilEkle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function para(kurus) {
    try {
      return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(kurus / 100) + ' TL';
    } catch (e) {
      return (kurus / 100).toFixed(2) + ' TL';
    }
  }

  /* Sepet durumundan mesaj + ilerleme uret */
  function durumHesapla(sepet) {
    var adet = sepet.item_count || 0;
    if (adet < 1) return null;

    var bedava = Math.floor(adet / GRUP);
    var kalan = GRUP - (adet % GRUP);
    if (kalan === GRUP) kalan = 0; /* tam katsa eksik yok */

    var oran = kalan === 0 ? 1 : (adet % GRUP) / GRUP;
    var indirim = sepet.total_discount || 0;

    var mesaj, alt;
    if (bedava === 0) {
      mesaj = '<b>' + kalan + ' ürün daha ekle</b>, 3’üncüsü bedava.';
      alt = '3 AL 2 ÖDE tüm ürünlerde geçerli. İkisini al, en ucuzu hediye.';
    } else if (kalan === 0) {
      mesaj = '🎉 <b>3 AL 2 ÖDE uygulandı.</b> ' + bedava + ' ürün bedava.';
      alt = indirim > 0
        ? 'Kazancın: <span class="chm-bxgy__kazanc">' + para(indirim) + '</span>'
        : 'İndirim ödeme adımında uygulanır.';
    } else {
      mesaj = '🎉 <b>' + bedava + ' ürün bedava.</b> ' + kalan + ' ürün daha ekle, bir tane daha bedava.';
      alt = indirim > 0
        ? 'Şu ana kadar kazancın: <span class="chm-bxgy__kazanc">' + para(indirim) + '</span>'
        : 'İndirim ödeme adımında uygulanır.';
    }

    return { mesaj: mesaj, alt: alt, oran: oran, tamam: bedava > 0, imza: adet + ':' + indirim };
  }

  function ciz(sepet) {
    var d = durumHesapla(sepet);

    if (!d) {
      document.querySelectorAll('.chm-bxgy').forEach(function (n) { n.remove(); });
      return;
    }

    document.querySelectorAll('.cart__summary-totals').forEach(function (toplam) {
      var kap = toplam.parentNode;
      if (!kap) return;

      var kutu = kap.querySelector(':scope > .chm-bxgy');
      if (!kutu) {
        kutu = document.createElement('div');
        kutu.className = 'chm-bxgy';
        kap.insertBefore(kutu, toplam);
      }

      if (kutu.getAttribute('data-imza') === d.imza) return;

      kutu.className = 'chm-bxgy' + (d.tamam ? ' chm-bxgy--tamam' : '');
      kutu.innerHTML =
        '<p class="chm-bxgy__mesaj">' + d.mesaj + '</p>' +
        '<div class="chm-bxgy__bar"><span class="chm-bxgy__dolu" style="width:' + Math.round(d.oran * 100) + '%"></span></div>' +
        '<p class="chm-bxgy__alt">' + d.alt + '</p>';
      kutu.setAttribute('data-imza', d.imza);
    });
  }

  var sonZaman = 0;

  function tara() {
    stilEkle();
    if (!document.querySelector('.cart__summary-totals')) return;

    var simdi = (window.performance && performance.now) ? performance.now() : 0;
    if (simdi - sonZaman < 400) return;
    sonZaman = simdi;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(ciz)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tara);
  } else {
    tara();
  }

  /* Horizon sepeti morph ile yeniden cizer, enjekte edilen dugum silinebilir.
     tara() idempotent oldugu icin dongu olusmaz. */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      clearTimeout(window.__charmeaseTara);
      window.__charmeaseTara = setTimeout(tara, 80);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
